import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setQuestions, setStep } from '../../../redux/reducers/models'
import ButtonStart from '../../ButtonStart'
import Arrow from '../../../assets/Images/Arrow.png'

const NextScreen = () => {
  const { questions, step, speakerOption } = useSelector(
    (state) => state.models
  )
  const dispatch = useDispatch()

  const handleNextClick = () => {
    if (speakerOption === 1) {
      dispatch(setQuestions(4))
      dispatch(setStep(4))
    } else {
      dispatch(setQuestions(questions + 1))
      dispatch(setStep(step + 1))
    }
  }

  const handleGoBackClick = () => {
    dispatch(setQuestions(questions - 1))
    dispatch(setStep(step - 1))
  }

  const refreshPage = () => {
    window.location.reload(true)
  }

  const renderGoBackButton = () => {
    if (questions !== 1 && questions !== 5) {
      return (
        <button onClick={handleGoBackClick} className='returnBTN' type='button'>
          Go Back
        </button>
      )
    }
    return null
  }

  const renderArrowButton = () => {
    if (questions === 5) {
      return (
        <button onClick={refreshPage} className='arrowBtn' type='button'>
          <img src={Arrow} alt='arrow' />
        </button>
      )
    }
    return null
  }

  return (
    <div className='ModelSelector__next'>
      {questions === 1
        ? (
        <p>Click Next To Continue</p>
          )
        : (
        <>
          {renderGoBackButton()}
          {renderArrowButton()}
        </>
          )}
      {questions !== 5 && (
        <ButtonStart onClick={handleNextClick}>Next</ButtonStart>
      )}
    </div>
  )
}

export default NextScreen
